import { gql } from '@apollo/client';

export const addDocument = gql`
  mutation addIdentityValidationDocument(
    $identityValidationId: String!
    $documentToAdd: IdentityValidationDocumentName!
    $fileExtension: FileExtension!
  ) {
    addIdentityValidationDocument(
      identityValidationId: $identityValidationId
      documentToAdd: $documentToAdd
      fileExtension: $fileExtension
    ) {
      value
    }
  }
`;
